"use client";

import { Children, ReactNode } from "react";

import { usePageScroll } from "../providers/PageScrollProvider";

// This component is used to handle the scroll refs for the special page
// in order to be able to pre-render these sections on the server, and only move the scrolling
// functionality to the client.

export function ScrollSections({
  children,
}: {
  children: ReactNode | ReactNode[];
}) {
  const { contentSectionRef, tourSectionRef, bioSectionRef } = usePageScroll();

  const sections = Children.toArray(children);

  return (
    <>
      <section ref={contentSectionRef}>{sections[0] ?? null}</section>
      <section ref={tourSectionRef}>{sections[1] ?? null}</section>
      <section ref={bioSectionRef} className="bg-black/5">
        {sections[2] ?? null}
      </section>
    </>
  );
}
